module.exports = __webpack_public_path__ + "static/media/airbag-pasajero.ca63e5f8.png";